<div class="flex min-h-screen bg-white">
  <!-- Partie gauche - Image -->
  <div class="w-1/2 hidden md:block image-container">
    <img src="assets/Innov.png" alt="Innov Impact Africa"
      class="object-cover w-[678] h-[910] mx-auto py-4" />
  </div>

  <!-- Partie droite - Formulaire -->
  <div class="w-full md:w-1/2 flex flex-col justify-center px-8 py-12">
    <div class="max-w-lg mx-auto w-full">
      <!-- Logo -->
      <div class="text-center mb-6">
        <img src="assets/images/UKUBHALISA.png" alt="Logo UKUBHALISA" class="h-12 mx-auto mb-4" />
      </div>

     <!-- Language Selector Styled -->
<div class="flex justify-end mb-4">
  <div class="relative">

    <select
      [(ngModel)]="languageService.currentLang"
      (change)="languageService.changeLanguage(languageService.currentLang())"
      class="appearance-none h-9 pl-9 pr-8 py-1 bg-white border border-gray-300 rounded-lg text-sm font-medium text-gray-700 transition-all cursor-pointer hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-[#063970] focus:border-[#063970]">

      <option value="FR">FR</option>
      <option value="EN">EN</option>
    </select>

    <!-- Icône drapeau dynamique -->
    <div class="absolute left-2 top-1/2 transform -translate-y-1/2 pointer-events-none">

      <!-- France -->
      <svg *ngIf="languageService.currentLang() === 'FR'" width="20" height="15" viewBox="0 0 900 600"
        xmlns="http://www.w3.org/2000/svg">
        <rect width="900" height="600" fill="#ED2939" />
        <rect width="600" height="600" fill="#fff" />
        <rect width="300" height="600" fill="#002395" />
      </svg>

      <!-- UK -->
      <svg *ngIf="languageService.currentLang() === 'EN'" width="20" height="15" viewBox="0 0 60 30"
        xmlns="http://www.w3.org/2000/svg">
        <clipPath id="s-lang">
          <path d="M0,0 v30 h60 v-30 z" />
        </clipPath>
        <clipPath id="t-lang">
          <path d="M30,15 h30 v15 z v-30 h-30 z h-30 v15 z v-15 h30 z" />
        </clipPath>
        <g clip-path="url(#s-lang)">
          <path d="M0,0 v30 h60 v-30 z" fill="#012169" />
          <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" stroke-width="6" />
          <path d="M0,0 L60,30 M60,0 L0,30" clip-path="url(#t-lang)" stroke="#C8102E" stroke-width="4" />
          <path d="M30,0 v30 M0,15 h60" stroke="#fff" stroke-width="10" />
          <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" stroke-width="6" />
        </g>
      </svg>

    </div>

    <!-- Icône flèche -->
    <div class="absolute right-2 top-1/2 transform -translate-y-1/2 pointer-events-none">
      <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M19 9l-7 7-7-7"></path>
      </svg>
    </div>

  </div>
</div>


      <!-- Alerte -->
      <div *ngIf="currentAlert.show" class="mb-4 p-4 rounded-lg" [ngClass]="{
             'bg-green-100 border border-green-400 text-green-700': currentAlert.type === 'success',
             'bg-red-100 border border-red-400 text-red-700': currentAlert.type === 'error',
             'bg-yellow-100 border border-yellow-400 text-yellow-700': currentAlert.type === 'warning'
           }">
        <div class="flex items-start">
          <svg *ngIf="currentAlert.type === 'success'" class="w-5 h-5 mr-2 flex-shrink-0" fill="currentColor"
            viewBox="0 0 20 20">
            <path fill-rule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
              clip-rule="evenodd" />
          </svg>
          <svg *ngIf="currentAlert.type === 'error'" class="w-5 h-5 mr-2 flex-shrink-0" fill="currentColor"
            viewBox="0 0 20 20">
            <path fill-rule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
              clip-rule="evenodd" />
          </svg>
          <svg *ngIf="currentAlert.type === 'warning'" class="w-5 h-5 mr-2 flex-shrink-0" fill="currentColor"
            viewBox="0 0 20 20">
            <path fill-rule="evenodd"
              d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 102 0V6a1 1 0 00-1-1z"
              clip-rule="evenodd" />
          </svg>
          <span class="flex-1">{{ currentAlert.message }}</span>
        </div>
      </div>

      <!-- Bouton de retour -->
      <!-- <div class="mb-6">
        <button (click)="navigateToHome()"
          class="flex items-center bg-gray-100 justify-center w-10 h-10 lg:w-12 lg:h-12 border border-gray-300 rounded-lg transition-colors hover:bg-gray-200">
          <svg class="w-5 h-5 lg:w-6 lg:h-6 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
          </svg>
        </button>
      </div> -->

      <!-- En-tête -->
      <div class="mx-auto mb-8">
        <h1 class="text-4xl font-bold text-gray-800 mb-2">{{ t('auth.login.title') }}</h1>
        <p class="text-lg text-gray-600">{{ t('auth.login.subtitle') }}</p>
      </div>

      <!-- Formulaire de connexion -->
      <form [formGroup]="currentLoginForm" (ngSubmit)="onSubmit()" *ngIf="currentActiveTab === 'connexion'">
        <!-- Champ Email/Téléphone -->
        <div class="mb-4">
          <label for="email" class="block text-gray-700 font-medium mb-2">{{ t('auth.login.emailLabel') }}</label>
          <input type="tel" id="email" formControlName="email" [placeholder]="t('auth.login.emailPlaceholder')"
            class="w-full px-4 py-3 rounded-lg focus:outline-none focus:ring-2 border border-gray-300 focus:border-[#063970] transition-all"
            [class.border-red-500]="currentLoginForm.get('email')?.invalid && currentLoginForm.get('email')?.touched"
            [disabled]="currentIsLoading" />
          <div *ngIf="currentEmailError" class="text-red-500 text-sm mt-1 flex items-center">
            <svg class="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                clip-rule="evenodd" />
            </svg>
            {{ currentEmailError }}
          </div>
        </div>

        <!-- Champ Mot de passe -->
        <div class="mb-2">
          <label for="password" class="block text-gray-700 font-medium mb-2">{{ t('auth.login.passwordLabel') }}</label>
          <div class="relative">
            <input [type]="currentShowPassword ? 'text' : 'password'" id="password" formControlName="password"
              [placeholder]="t('auth.login.passwordPlaceholder')"
              class="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#063970] border-gray-300 transition-all"
              [class.border-red-500]="currentLoginForm.get('password')?.invalid && currentLoginForm.get('password')?.touched"
              [disabled]="currentIsLoading" />
            <button type="button" (click)="togglePasswordVisibility()"
              class="absolute right-3 top-1/2 transform -translate-y-1/2 hover:opacity-70 transition-opacity"
              [disabled]="currentIsLoading">
              <svg *ngIf="!currentShowPassword" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                stroke="currentColor" class="h-5 w-5 text-gray-500">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
              <svg *ngIf="currentShowPassword" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                stroke="currentColor" class="h-5 w-5 text-gray-500">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 104.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
              </svg>
            </button>
          </div>
          <div *ngIf="currentPasswordError" class="text-red-500 text-sm mt-1 flex items-center">
            <svg class="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                clip-rule="evenodd" />
            </svg>
            {{ currentPasswordError }}
          </div>
        </div>

        <div class="flex justify-between items-center mb-6">
          <!-- Lien Register -->
          <a href="/register" class="text-sm underline italic transition-colors" style="color: #063970">
            {{ t('auth.login.createAccount') }}
          </a>
          <!-- Lien Mot de passe oublié -->
          <a href="/resetpassword"
            class="text-sm text-gray-600 underline italic transition-colors" style="color: #063970">
            {{ t('auth.login.forgotPassword') }}
          </a>
        </div>

        <!-- Bouton de connexion -->
        <button type="submit" [disabled]="currentIsLoading"
          class="w-full text-white py-3 rounded-lg font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
          [style.background]="currentIsLoading ? 'linear-gradient(to right, #4a6fa5, #5a7fb5)' : 'linear-gradient(to right, #063970, #084a8c)'"
          [style.opacity]="currentIsLoading ? 0.7 : 1">
          <span *ngIf="!currentIsLoading">{{ t('auth.login.loginButton') }}</span>
          <span *ngIf="currentIsLoading" class="flex items-center justify-center">
            <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none"
              viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
              </path>
            </svg>
            {{ t('auth.login.loggingIn') }}
          </span>
        </button>
      </form>
    </div>
  </div>
</div>